import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { useTopCountriesData } from "app/pages/industry-analysis/overview/widgets/top-countries/single/useTopCountriesData";
import { TrafficTopCountries } from "app/components/TrafficTopCountries/TrafficTopCountries";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import DurationService from "app/services/DurationService";

export const TopCountries = () => {
    const { params } = useCurrentStateAndParams();
    const { duration, webSource } = params;
    const textKeys = {
        titleKey: "market.research.market.analysis.top.countries.header.title",
        titleTooltipKey: "market.research.market.analysis.top.countries.header.title.tooltip",
    };
    const { isLoading, countriesTrafficShare } = useTopCountriesData();
    const ctaHref = {
        href: proNavigator.href("market_research_geography", params),
        target: "_self",
    };
    const { from, to } = useMemo(() => DurationService.getDurationData(duration).forAPI, [duration]);

    const subtitleFilters = [
        {
            filter: "date",
            value: {
                from,
                to,
            },
        },
    ];
    return (
        <TrafficTopCountries
            countriesTrafficShare={countriesTrafficShare}
            textKeys={textKeys}
            isLoading={isLoading}
            ctaHref={ctaHref}
            params={{ duration, webSource }}
            subtitleFilters={subtitleFilters}
        />
    );
};
